import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Opdata } from 'src/app/models/opdata.model';
import { OpdataCalc } from 'src/app/models/opdataCalc.model';
import { Stage } from 'src/app/models/stage.interface';
import { Train } from 'src/app/models/train.model';
import { OpdataService } from 'src/app/services/opdata/opdata.service';
import { TrainService } from 'src/app/services/trains/trains.service';
import { PlotlyService } from '../plotly.service';
import { param } from 'jquery';
import { PlantsService } from 'src/app/services/plants/plants.service';
import { Plant } from 'src/app/models/plant.model';
import { ListConductivityprofiles } from 'src/app/models/conductivityprofiles.model';
import {DateWiseCpData} from 'src/app/models/conductivityprofiles.model';
import { ConductivityprofilesService } from 'src/app/services/conductivityprofiles/conductivityprofiles.service';

@Component({
  selector: 'app-conductivityprofilegraph',
  templateUrl: './conductivityprofilegraph.component.html',
  styleUrls: ['./conductivityprofilegraph.component.scss']
})
export class ConductivityprofilegraphComponent {
  opCalData: OpdataCalc[] = []
  plantName: string = ""
  trainDetails: Train = new Train();
  public WindowRef : Window;
  NewWidth: any;
  trainId: string = ""
  plantId: string = ""
  showselector: boolean = false;
  public stage3: Array<Stage> = [
    { Id: 1, Name: 'Total' },
    { Id: 2, Name: '1' },
    { Id: 3, Name: '2' },
    { Id: 4, Name: '3'},
  ];
  public stage2: Array<Stage> = [
    { Id: 1, Name: 'Total' },
    { Id: 2, Name: '1' },
    { Id: 3, Name: '2' },
    
  ];
  public stageTotal: Array<Stage> = [
    { Id: 1, Name: 'Total' }, 
  ];
  Stage1: string = "1"
  Stage2: string = "1"
  Stage3: string = "1"

  date1="0";
  date2="0";
  date3="0";
  plants: Plant[] = [];
  trains: Train[] = [];
  plantDetails: Plant = new Plant();
  loggedInUserRole:string;
  loggedinUserId:string;
  plantAndUserId:string;

  conductivityprofile : ListConductivityprofiles[] = [];
  filteredCpData1 : ListConductivityprofiles[] = [];
  filteredCpData2 : ListConductivityprofiles[] = [];
  filteredCpData3 : ListConductivityprofiles[] = [];

  filterdCpdataStage1 : ListConductivityprofiles[] = [];
  filterdCpdataStage2 : ListConductivityprofiles[] = [];
  filterdCpdataStage3 : ListConductivityprofiles[] = [];
  tableData: any;
  tableDates:any;
  distinctDates:any;
  conductivityprofilesservice: any;
  constructor(
    private plot: PlotlyService, 
    private trainService: TrainService,
    private plantService: PlantsService,
    private route: ActivatedRoute, 
    private opdataService: OpdataService,
    private conductivityservices :ConductivityprofilesService

  ) {
    this.route.queryParams.subscribe(params => {
      this.showselector = params["showselector"];
      this.trainId = params['trainId'];
      this.plantId = params['plantId'];
      this.plantName = params["plantName"];
    });
  }
  

  ngOnInit(): void {
    this.WindowRef = window;
    console.log(this.WindowRef.innerWidth);
    this.NewWidth = 1500;
    if (this.WindowRef.innerWidth > 1500) {
      this.NewWidth = this.WindowRef.innerWidth;
    }
    if (this.plantId === undefined || this.plantId === null ) {
      this.plantloader()
    } else {
      this.getTrainById();
      this.getdistinctDatesOfConductivityprofileByTrainId();
    }

         //Subscribe to selectedPlant$ to get the plantId when it changes
    this.plantService.selectedPlant$.subscribe(plantId => {
      if (plantId) {
        this.getSelectedId({
          target: {
            value: plantId
          }
        });
      }
    });
        

    // Subscribe to selectedTrain$ to get the trainId when it changes
    this.plantService.selectedTrain$.subscribe(trainId => {
      if (trainId) {
        this.trainId = trainId.toString();
        this.getSelectedTrainId({
          target: {
            value: this.trainId
          }
        });
      }
    });
    
  }
  plantloader(){
    let loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
    if(loggedInuserRole.role =='Standard User')
    {
      this.loggedInUserRole = loggedInuserRole.role;
      this.loggedinUserId = loggedInuserRole.userId;

      this.plantService.getPlantsByUserId(loggedInuserRole.userId)
      .subscribe({
        next: (plants)=>{
          this.plants = plants;
        },
      })
      
    }
    else
    {
    this.plantService.getAllPlant().subscribe({
      next: (plants) => {
        this.plants = plants;
      },
      error: (response) => {
        console.log(response);
      },
    });
  }
  }
  getSelectedId(e) {
    this.plantId = e.target.value;
    this.plantService.getPlant(this.plantId).subscribe({
      next: (response) => {
        this.plantDetails = response;
        console.log(this.plantDetails);
      },
    });

    this.plantName = this.plantDetails.Name;
    if(this.loggedInUserRole =='Standard User')
      {
          this.plantAndUserId = this.plantId + 'Z' + this.loggedinUserId;
          this.trainService.GetAccessibleTrainListByPlantId(this.plantAndUserId ).subscribe(
           
            (response: Train[]) => {
              this.trains = response;
              console.log(this.trains);
              
            },
      
            (error: any) => {
              console.log('error list');
            }
          );
      }
      else
      {
    this.trainService.getTrainByPlantId(this.plantId).subscribe(
      (response: Train[]) => {
        this.trains = response;
      },
      (error: any) => {
        console.log('error list');
      }
    );
  }
}
  getSelectedTrainId(e) {
    this.trainId = e.target.value;
    this.getTrainById();
    
  }
  onOptionSelected() {
    let stageStr = this.trainDetails.Stages.toString();
   
    if (stageStr === '2') 
    {

    } else if (stageStr === '3') 
    {

    } 
    else 
    {

    }
    
  }
  getTrainById() {
    console.log(this.trainId)
    this.trainService.getTrainById(this.trainId).subscribe({
      next: (response) => {
        this.trainDetails = response;
        this.getConductivityprofilesListByTrainId();
        this.getdistinctDatesOfConductivityprofileByTrainId();
      },
    });
  }
  getConductivityprofilesListByTrainId()
  {
    this.conductivityservices.getConductivityprofilesListByTrainId(this.trainId).subscribe({
        next:(response) => {
          this.conductivityprofile = response;
          console.log(this.conductivityprofile);
        }

    });
  }
  getdistinctDatesOfConductivityprofileByTrainId()
  {
    this.conductivityservices.getdistinctDatesOfConductivityprofileByTrainId(this.trainId).subscribe({
      next:(response) =>{
        this.distinctDates = response;
        console.log(this.distinctDates);
      }
    });
  }
  showGraph()
  {
    
    this.getConductivityprofilesListByTrainId();
    this.getConductivityProfileGraphData();
  }
  
  
getConductivityProfileGraphData()
{
  let x: string[] = [];
  let y: string[] = [];
  let y1: string[] = [];
  let y2: string[] = [];
  let y3: number[] = [];
  let yname: string = "";
  let y1name: string = "";
  let y2name: string = "";
  let y3name: string = "";

  const getStageLabel = (stageNumber: string | number) => {
  if (stageNumber == 1) return 'Total';
  if (stageNumber == 2) return 'Stage 1';
  if (stageNumber == 3) return 'Stage 2';
  return ''; 
};
   const stageLabel1 = getStageLabel(this.Stage1);
  if (this.date1 !="0" && this.date2 =="0" && this.date3 =="0") 
  {
  this.filteredCpData1 = this.conductivityprofile.filter(x =>x.TableshortcodeDatetime == this.date1);
  if(this.Stage1=='2')
  {
  this.filterdCpdataStage1 = this.filteredCpData1.filter(x => x.Stage == '1');
  console.log(this.filteredCpData1);
  this.filterdCpdataStage1.forEach(element => {
    x.push(element.PvId);
    y.push(element.PermCond);
  
    });
  }
  else if(this.Stage1=='3')
  {
    this.filterdCpdataStage2 = this.filteredCpData1.filter(x => x.Stage == '2');

     this.filterdCpdataStage2.forEach(element => {
       x.push(element.PvId);
       y.push(element.PermCond);
     
       });
  }
  else if(this.Stage1=='4')
  {
    this.filterdCpdataStage3 = this.filteredCpData1.filter(x => x.Stage == '3');

     this.filterdCpdataStage3.forEach(element => {
       x.push(element.PvId);
       y.push(element.PermCond);
     
       });
  }
  else
  {
    this.filteredCpData1 = this.conductivityprofile.filter(x =>x.TableshortcodeDatetime == this.date1);
    this.filteredCpData1.forEach(element => {
      x.push(element.PvId);
      y.push(element.PermCond);
    
      });
  }

       this.plot.plotLineCpGraphWithDate1("", "plot", x,y,this.date1,stageLabel1); 
  
  }
    if (this.date1 !="0" && this.date2 !="0" && this.date3=="0") 
    { 
      this.filteredCpData1 = this.conductivityprofile.filter(x =>x.TableshortcodeDatetime == this.date1);
      if(this.Stage1=="2")
      {
       this.filterdCpdataStage1 = this.filteredCpData1.filter(x => x.Stage == '1');
       this.filterdCpdataStage1.forEach(element => {
         x.push(element.PvId);
         y.push(element.PermCond);
       
         });
        
        this.filteredCpData2 = this.conductivityprofile.filter(x =>x.TableshortcodeDatetime == this.date2);
        this.filterdCpdataStage1 = this.filteredCpData2.filter(x => x.Stage == '1');
       this.filterdCpdataStage1.forEach(element => {
       
         y1.push(element.PermCond);
       
         });
        }
        else if(this.Stage1=="3")
        {

          this.filterdCpdataStage2 = this.filteredCpData1.filter(x => x.Stage == '2');
          this.filterdCpdataStage2.forEach(element => {
          x.push(element.PvId);
          y.push(element.PermCond);
       
         });
        
        this.filteredCpData2 = this.conductivityprofile.filter(x =>x.TableshortcodeDatetime == this.date2);
        this.filterdCpdataStage2 = this.filteredCpData2.filter(x => x.Stage == '2');
       this.filterdCpdataStage2.forEach(element => {
       
         y1.push(element.PermCond);
       
         });
        }
        else if(this.Stage1=="4")
        {
          this.filterdCpdataStage3 = this.filteredCpData1.filter(x => x.Stage == '3');
          this.filterdCpdataStage3.forEach(element => {
          x.push(element.PvId);
          y.push(element.PermCond);
       
         });
        
        this.filteredCpData2 = this.conductivityprofile.filter(x =>x.TableshortcodeDatetime == this.date2);
        this.filterdCpdataStage3 = this.filteredCpData2.filter(x => x.Stage == '3');
       this.filterdCpdataStage3.forEach(element => {
       
         y1.push(element.PermCond);
        });
      }
      else
      {
        this.filteredCpData1 = this.conductivityprofile.filter(x =>x.TableshortcodeDatetime == this.date1);
        console.log(this.filteredCpData1);
       this.filteredCpData1.forEach(element => {
         x.push(element.PvId);
         y.push(element.PermCond);
       
         });
      }
      this.plot.plotLineCpGraphWithDate2("", "plot", x,y,y1,this.date1,this.date2,stageLabel1); 
    }
    if (this.date1 !="0" && this.date2!="0" && this.date3!="0") 
    { 
      this.filteredCpData1 = this.conductivityprofile.filter(x =>x.TableshortcodeDatetime == this.date1);
      console.log(this.filteredCpData1);
       this.filteredCpData1.forEach(element => {
         x.push(element.PvId);
         y.push(element.PermCond);
       
         });
      this.filteredCpData2 = this.conductivityprofile.filter(x =>x.TableshortcodeDatetime == this.date2);
      console.log(this.filteredCpData2);
       this.filteredCpData2.forEach(element => {
       
         y1.push(element.PermCond);
       
         });
         this.filteredCpData3 = this.conductivityprofile.filter(x =>x.TableshortcodeDatetime == this.date3);
         console.log(this.filteredCpData3);
          this.filteredCpData3.forEach(element => {
          
            y2.push(element.PermCond);
          
            });
      this.plot.plotLineCpGraphWithDate3("", "plot", x,y,y1,y2,this.date1,this.date2,this.date3,stageLabel1);
      
    }
}

}
